export const showStatusOverlay = () => {
  $("#batchgeo-status-overlay").show();
};

export const hideStatusOverlay = () => {
  $("#batchgeo-status-overlay").hide();
};
